import React, { useContext } from 'react';
import { RicosContext, EditorContext, ModalContext, PluginsEventsContext } from 'ricos-context';
import VerticalEmbedInsertModal from '../toolbar/VerticalEmbedInsertModal.js';
import { VERTICAL_EMBED_TYPE } from '../types.js';
import 'prop-types';
import 'wix-rich-content-common';
import 'wix-rich-content-plugin-commons';
import 'wix-rich-content-ui-components';
import '../ItemsList-fa31729c.js';
import 'classnames';
import '../style-inject.es-746bb8ed.js';
import '../toolbar/itemsList/Item.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../dataHooks.js';
import '../constants.js';
import 'ricos-schema';
import '../convertDuration.js';
import 'lodash';

const InsertModal = ({
  componentData,
  verticalsApi,
  nodeId,
  modalId,
  showCloseButton
}) => {
  const { locale, t, isMobile, experiments } = useContext(RicosContext);
  const { getEditorCommands } = useContext(EditorContext);
  const modalService = useContext(ModalContext) || {};
  const pluginsEvents = useContext(PluginsEventsContext);
  const closeModal = () => {
    modalService.closeModal(modalId);
  };
  const addBlockWithFocus = (insertBlock) => setTimeout(() => insertBlock(), 50);
  const onConfirm = (verticalEmbed) => {
    const editorCommands = getEditorCommands();
    let insertVertical = () => {
      editorCommands == null ? void 0 : editorCommands.insertBlockWithBlankLines(VERTICAL_EMBED_TYPE, verticalEmbed);
    };
    if (nodeId) {
      insertVertical = () => {
        editorCommands == null ? void 0 : editorCommands.setBlock(nodeId, VERTICAL_EMBED_TYPE, verticalEmbed);
      };
    }
    addBlockWithFocus(insertVertical);
    closeModal();
  };
  const pluginEvents = {
    onPluginsPopOverClick: (data) => pluginsEvents.publishPluginPopoverClick(data)
  };
  return /* @__PURE__ */ React.createElement(
    VerticalEmbedInsertModal,
    {
      componentData,
      t,
      isMobile,
      locale,
      verticalsApi,
      onConfirm,
      experiments,
      onCloseRequested: closeModal,
      helpers: pluginEvents,
      showCloseButton
    }
  );
};

export { InsertModal as default };
//# sourceMappingURL=InsertModal.js.map
